import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import Maguey from '../../../img/magueysito.svg'
import LogoMagueySVG from '../../../img/logoBlancoSVG2.svg';
import { greatPlaceStyle, greatPlaceStyleHover } from './EstilosHoverMap';
import estilos from './MarcadorDeZonaComponent.module.css'


function MarcadorDeZonaComponent(props) {

    const { color, name, id } = props;
    const localidad = props.localidad

    const [mostrarVentanita, setMostrarVentanita] = React.useState(false);

    const handleMostrarVentanita = () => {
        setMostrarVentanita(true);
    }

    const handleCerrarVentanita = () => {
        setMostrarVentanita(false);

    }


    return (

        <Fragment>

            {
                mostrarVentanita ? (
                    <Fragment>
                        <div style={{backgroundColor:'white',width:'300px', height:'100px !important',fontSize:'15px',zIndex:1}}>
                            <div className='container'>
                            <p >Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit iste illum, qui voluptatum unde molestias libero ex explicabo possimus corrupti placeat consectetur, modi sed veritatis laboriosam ipsa neque consequatur quis.</p>
                            </div>
                        </div >
                    </Fragment>
                ) :
                    (<></>)
            }

            <div onMouseOver={handleMostrarVentanita} onMouseOut={handleCerrarVentanita} title={name}>
                <div className={`${estilos.pin1}`} style={{ backgroundColor: color, cursor: 'pointer', textAlign: 'center !important' }}>
                    <img src={LogoMagueySVG} />
                    <p className='badge' style={{ backgroundColor: 'white', fontSize: '15px', color: 'black' }}>{localidad.nombrelocalidad}</p>
                </div>

            </div>



        </Fragment>
    );
};


export default withRouter(MarcadorDeZonaComponent)
